module.exports = __webpack_public_path__ + "img/claim_icon.92e45860.svg";